(function () {
  var root = document.documentElement;

  function setPageHeight() {
    // Only measure document.body, not document.documentElement: the decoration
    // layer's containing block is the root, so its own height leaks into
    // documentElement.scrollHeight/offsetHeight and would feed back into itself
    // on every re-measurement.
    var height = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight
    );
    root.style.setProperty('--bg-decoration-page-height', height + 'px');
  }

  setPageHeight();
  window.addEventListener('load', setPageHeight);
  window.addEventListener('resize', setPageHeight);

  if (window.ResizeObserver) {
    new ResizeObserver(setPageHeight).observe(document.body);
  }
})();
